<!--
ALTERAÇÃO DA SERIE E NUMERO DA NF
-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
  props: {
    nf: { type: Object },
  },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: '',
      serie: '',
      numero: 0,
      serienf: []
    }
  },

  computed: {
    serienfList: function () {
      let series = []
      this.$store.getters.getSerienfList.map((ser) => {
        series.push({ id: ser.serie, text: ser.serie, nf: ser.nf })
      })
      return series
    },
  },

  methods: {
    handleSalvar() {
      if (this.serie === '' || this.nf.serie === null || this.numero === '0' || this.numero === null) {
        this.errmessages = 'Por favor preencha corretamente os campos'
        return
      } else {
        this.errmessages = ''
      }
      this.nf.serie = this.serie
      this.nf.nf = this.numero
      this.$emit('save')
    },
    loadSerieList() {
      this.$store.dispatch('loadSerienf', { filter: this.filter, page: this.nextPage })
    },
    handleCancelar(index) {
      this.$emit('closeform')
    },

  },

  watch: {
    'serie': function () {
      if (this.serienfList.length > 0) {
        const vserie = this.serienfList.find((item) => item.id == this.serie)
        if (vserie) {
          this.numero = vserie.nf
        }
      }
    },

  },

  created() {
    this.loadSerieList()
    this.serie = this.nf.serie
    this.numero = this.nf.nf
    this.$nextTick(function () {
      this.$refs.serie.$el.querySelector('input').focus()
    })
  }

}

</script>

<template>
  <transition name="fade">
    <div id="mymodal" class="nb-modal-scrollable">
      <div class="container nb-modal-scrollable-container" style="width: 500px">
        <div class="nb-modal-header">
          <h4 class="def-title"> Alterar Número da Nota Fiscal </h4>
          <button type="button" class="close" @click="handleCancelar" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div>
          <br>
          <div v-if="errmessages">
            <div class="col">
              <div class="alert alert-warning fade show" role="alert">
                <h5 class="alert-heading">Erro:</h5>
                <button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>
                <p><small>{{ errmessages }}</small></p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="lbl">Informe a nova numeração para a nota fiscal.</span>
            </div>
          </div>
          <br>
          <div class="row">
            <form-field ref="serie" v-model="serie" type="select" :selectOptions="serienfList" col="6"
              :metadata="metadata.nf.serie" name="serie" :v-errors="errors"
              v-validate="metadata.nf.serie.validator"></form-field>
            <form-field v-model="numero" type="number" col="6" :metadata="metadata.nf.nf" name="nf" :v-errors="errors"
              v-validate="metadata.nf.nf.validator"></form-field>
          </div>
          <div class="nb-modal-scrollable-footer">
            <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSalvar"></v-button>
            <v-button ref="btnClose" label="Cancelar" title="" @click="handleCancelar"></v-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style></style>



// WEBPACK FOOTER //
// src/forms/nf-form-numero.vue